import { render, staticRenderFns } from "./DatiClientePerFattura.vue?vue&type=template&id=91c3ebfa&scoped=true&"
import script from "./DatiClientePerFattura.vue?vue&type=script&lang=js&"
export * from "./DatiClientePerFattura.vue?vue&type=script&lang=js&"
import style0 from "./DatiClientePerFattura.vue?vue&type=style&index=0&id=91c3ebfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c3ebfa",
  null
  
)

export default component.exports
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QOptionGroup,QInput});
